// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, LoginApi } from "../Utils/Constants";

export const LoginData = createAsyncThunk("LoginData", async (payload) => {
  try {
    const config = {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    };
    const url = ApiBaseUrl + LoginApi;
    const response = await axios.post(url, payload, config);
    return response.data;
  } catch (error) {
    console.error("Error during login:", error);
    throw error;
  }
});

const loginSlice = createSlice({
  name: "loginReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearLoginData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(LoginData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(LoginData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(LoginData.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearLoginData } = loginSlice.actions;
export default loginSlice.reducer;
